export enum AppErrorCode {
  GENERIC_ERROR = 'GENERIC_ERROR',
  NETWORK_ERROR = 'NETWORK_ERROR',
  UNAUTHORIZED = 'UNAUTHORIZED',
  OAUTH_CALLBACK_INVALID = 'OAUTH_CALLBACK_INVALID',
  OAUTH_EXCHANGE_FAILED = 'OAUTH_EXCHANGE_FAILED',
  USER_NOT_REGISTERED = 'USER_NOT_REGISTERED',
}

export const DEFAULT_ERROR_MESSAGES: Record<AppErrorCode, string> = {
  [AppErrorCode.GENERIC_ERROR]: 'An unexpected error occurred. Please try again.',
  [AppErrorCode.NETWORK_ERROR]: 'A network error occurred. Please try again.',
  [AppErrorCode.UNAUTHORIZED]: 'Your session expired. Please log in again.',
  [AppErrorCode.OAUTH_CALLBACK_INVALID]: 'OAuth callback is invalid.',
  [AppErrorCode.OAUTH_EXCHANGE_FAILED]: 'Could not complete OAuth login.',
  [AppErrorCode.USER_NOT_REGISTERED]: 'Q-number is not registered.',
}

export type AppError = {
  //TODO: Make code: AppErrorCode when the backend is updated to send specific error codes
  code: string
  message: string
  status?: number
  requestId?: string
}
